import SidebarExpandIcon from '@atlaskit/icon/core/sidebar-expand';
import * as React from 'react';

export function SvgMenuShow() {
  return <SidebarExpandIcon label="" testId="ads-refreshed-icon" />;
}
